'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Check = Check;
exports.Widget = Widget;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

require('core-js/modules/es6.object.assign');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Cookie(name) {
    return '-optout-' + name;
}

function Set(name) {
    _jsCookie2.default.set(Cookie(name), '1', { expires: 36000 }); // ~100 years
}

function Unset(name) {
    _jsCookie2.default.remove(Cookie(name));
}

function Check(name) {
    return _jsCookie2.default.get(Cookie(name)) !== undefined;
}

function Widget(name, options) {
    var opts = Object.assign({
        // destNode: for example document.getElementById('optout-element'),
        template: function template(label, desc, additionalClass) {
            return '<div>\n                        <p class="optout-desc">' + desc + '</p>\n                        <a class="optout-button ' + additionalClass + '" href="#">' + label + '</a>\n                    </div>';
        },
        labelOptOut: 'Opt-out',
        labelOptIn: 'Opt-in',
        descOptOut: 'Click on the Opt-out button to opt out of data collection',
        descOptIn: 'Click on the Opt-in button to re-enable data collection'
    }, options);

    function toggle() {
        var optOutEnabled = Check(name);
        if (optOutEnabled) {
            Unset(name);
        } else {
            Set(name);
        }
        render();
    }

    function render() {
        var optOutEnabled = Check(name);
        var label = optOutEnabled ? opts.labelOptIn : opts.labelOptOut;
        var desc = optOutEnabled ? opts.descOptIn : opts.descOptOut;
        var additionalClass = optOutEnabled ? 'optout-enabled' : 'optout-disabled';
        opts.destNode.innerHTML = opts.template(label, desc, additionalClass);

        var button = opts.destNode.getElementsByClassName('optout-button')[0];
        button.addEventListener('click', function (e) {
            toggle();
            e.preventDefault();
        });
    }

    function init() {
        render();
    }

    init();
    return {
        toggle: toggle
    };
}


/** WEBPACK FOOTER **
 ** ./~/babel-loader!./~/eslint-loader!./optout.js
 **/